import React from "react";
import { FaArrowLeft, FaCheck } from "react-icons/fa";

function PortalFormPage({
  title,
  backLabel,
  onBack,
  onSubmit,
  submitting = false,
  submitLabel = "Save",
  submittingLabel = "Saving…",
  submitDisabled = false,
  showSubmitIcon = true,
  footerNote = null,
  className = "",
  children,
}) {
  return (
    <div className="cportal-form-page">
      <button type="button" className="cportal-back-link" onClick={onBack}>
        <FaArrowLeft /> {backLabel}
      </button>

      <div className="cportal-page-head">
        <h1>{title}</h1>
      </div>

      <form
        className={`cportal-card cportal-form-page-card${className ? ` ${className}` : ""}`}
        onSubmit={onSubmit}
        noValidate
      >
        <div className="cportal-form-page-body">{children}</div>
        <div className="cportal-form-actions cportal-form-page-actions">
          {footerNote ? <p className="cportal-form-page-note">{footerNote}</p> : null}
          <button
            type="button"
            className="cportal-btn cportal-btn-ghost"
            onClick={onBack}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="cportal-btn cportal-btn-primary"
            disabled={submitting || submitDisabled}
          >
            {submitting ? (
              <span className="cportal-btn-spinner" aria-hidden="true" />
            ) : showSubmitIcon ? (
              <FaCheck aria-hidden="true" />
            ) : null}
            {submitting ? submittingLabel : submitLabel}
          </button>
        </div>
      </form>
    </div>
  );
}

export default PortalFormPage;
